import React , {useState, useEffect} from 'react'
import axios from 'axios'
import {getUserData} from 'redux/UserAuthentication/LoginActions'
import Admin from "layouts/Admin";
import Client from "layouts/Client";
// import ClientLayout from "layouts/Auth";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
// const root = ReactDOM.createRoot(document.getElementById("root"));
import { Provider } from "react-redux";
import store from "redux/store";
import jwtDecode from 'jwt-decode'

import AuthRoute from 'util/AuthRoute';
import AdminRoute from "util/AdminRoute";
import ClientRoute from "util/ClientRoute";
import Login from 'views/pages/Login'
import {logoutUser} from 'redux/UserAuthentication/LoginActions'
import Register from 'views/pages/Register';
import ForgotPassword from 'views/pages/ForgotPassword';
import Swal from 'sweetalert2'
import { type } from 'jquery';
import { renewToken, saveTimeSpent } from 'redux/UserAuthentication/LoginActions';
import { useDispatch } from "react-redux";
import Home from 'views/WebsitePages/Home'
import DATDrillerHome from 'views/LandingPages/DATDrillerHome'
import BootcampAccept from 'views/pages/BootcampAccept'
import PresenceGate from "components/Messages/PresenceGate";
import AppNotifications from "components/Messages/AppNotifications";


axios.defaults.baseURL = 'https://us-central1-pre-dental-tracker.cloudfunctions.net/api';
// axios.defaults.baseURL = 'http://localhost:5002/pre-dental-tracker/us-central1/api';
// const FBIdToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTY5MDkzNDExNSwiZXhwIjoxNjkwOTM3NzE1LCJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay13NnNoOUB0cGNkYXNoYm9hcmQuaWFtLmdzZXJ2aWNlYWNjb3VudC5jb20iLCJzdWIiOiJmaXJlYmFzZS1hZG1pbnNkay13NnNoOUB0cGNkYXNoYm9hcmQuaWFtLmdzZXJ2aWNlYWNjb3VudC5jb20iLCJ1aWQiOiJVSVV5Y3ZGaHYxUnNLSTVLS0ZSek5tQk03VVoyIn0.huWm34b1x9m6Z7ouA6wnBiKJ-Z49UVacOSN6hje90wa3hHVNUgC0r3R879tbcCmiD7GyhGRnjQWH9sBNhjTrRdDAy5iZ0yGpjwA-v8EqZDAVExNqjb76tI8qWd-lmVy-2emH1N-o90l2Qy2etyxxCF6-kWVPWX39bpmjJRXddK2u0rkhFnrQtFjqimhyE-K_eRtsDNfV-kjW2zTwpeTKymmTO5UPMhnG87NoOlydkr0nPEFvPt7jCpN5x6rv_06MmMfrP4ceJsVHv2fnY5vD3PQMaGFfNtEkNATCezs0OpUqSJ-c-08scWgbdrkWJHgeJsTQ7f9korKlucCCKLpqPA"

// localStorage.setItem('FBIdToken', FBIdToken)
// axios.defaults.headers.common['Authorization'] = "Bearer "+ FBIdToken
// store.dispatch(getUserData({handle:"aringorstudent", onLogin:true}))

// const token = localStorage.FBIdToken
// if (token){
//   const decodedToken = jwtDecode(token)
//   // console.log(new Date(decodedToken.exp * 1000))
  
//   if (decodedToken.exp * 1000 < Date.now()){
//       // store.dispatch(refreshUser())
//       store.dispatch(logoutUser())    
//     //   window.location.reload()F
//         if (!localStorage.getItem('tokenExpired')) {
//             localStorage.setItem('tokenExpired', 'true');
//             window.location.reload(); // Reload the page
//         }

//   } 
//   else {
//         localStorage.removeItem('tokenExpired');
//         axios.defaults.headers.common['Authorization']=token
//         store.dispatch(getUserData({onLogin:true}))
        
//   }
// }

let login = false;
let prompt = false;
let authCheckInitialized = false;
let tokenCheckInterval = null;
let lastActivityTime = Date.now();
const IDLE_THRESHOLD = 2 * 60 * 1000; // 2 minutes of no activity = idle
const RENEW_BEFORE_EXPIRY = 5 * 60 * 1000; // Renew 5 minutes before expiry
const TOKEN_CHECK_INTERVAL = 60 * 60 * 1000; // Check token every 1 hour

// Track user activity
const updateActivity = () => { lastActivityTime = Date.now(); };
['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'].forEach(event => {
    document.addEventListener(event, updateActivity, { passive: true });
});

const isUserActive = () => (Date.now() - lastActivityTime) < IDLE_THRESHOLD;

const checkTokenExpiration = () => {

    let token = localStorage.FBIdToken;

    if (token) {
        const decodedToken = jwtDecode(token);
        const timeUntilExpiry = decodedToken.exp * 1000 - Date.now();

        if (timeUntilExpiry <= 0) {
            // Token already expired
            if(typeof token != "undefined"){

                if (isUserActive() && login) {
                    // User is active but token expired — silently renew
                    if (!prompt) {
                        prompt = true;
                        store.dispatch(renewToken({token : localStorage.getItem('FBRefreshToken')}));
                        setTimeout(() => { prompt = false; }, 10000);
                    }
                } else if(!prompt && login){
                    // User is idle and token expired — show modal
                    Swal.fire({

                        title: 'Session Expired',
                        text: "Your session is expired",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Stay Connected',
                        cancelButtonText: 'Logout'

                    }).then((result) => {

                        if (result.isConfirmed) {

                            console.log("stay connected")
                            store.dispatch(renewToken({token : localStorage.getItem('FBRefreshToken')}))

                            setTimeout(() => {
                                prompt = false;
                            }, 30000);


                        }
                        else{

                            localStorage.setItem('totalTime', 0);
                            store.dispatch(logoutUser())

                            if (!localStorage.getItem('tokenExpired')) {
                                localStorage.setItem('tokenExpired', 'true');

                                window.location.reload(); // Reload the page
                            }
                        }
                    })
                    prompt = true;
                }

                localStorage.removeItem('FBIdToken');


            }

        } else if (timeUntilExpiry <= RENEW_BEFORE_EXPIRY && isUserActive()) {
            // Token about to expire and user is active — silently renew early
            if (!prompt) {
                prompt = true;
                store.dispatch(renewToken({token : localStorage.getItem('FBRefreshToken')}));
                setTimeout(() => { prompt = false; }, 10000);
            }

        } else {

            if(!login){

                localStorage.removeItem('tokenExpired');
                axios.defaults.headers.common['Authorization'] = token;
                store.dispatch(getUserData({ onLogin: true }));
                login = true;

                // Timeout fallback: if getUserData hasn't resolved after 10s, unblock route guards
                setTimeout(() => {
                    const { authChecked } = store.getState().loginAuth;
                    if (!authChecked) {
                        console.warn('getUserData timed out, redirecting to login');
                        localStorage.removeItem("FBIdToken");
                        localStorage.removeItem("FBRefreshToken");
                        delete axios.defaults.headers.common['Authorization'];
                        store.dispatch({ type: 'SET_UNAUTHENTICATED' });
                        login = false;
                    }
                }, 10000);

                // Start hourly token check after login
                if (tokenCheckInterval) clearInterval(tokenCheckInterval);
                tokenCheckInterval = setInterval(checkTokenExpiration, TOKEN_CHECK_INTERVAL);

            }




        }
    } else {
        // No token exists - set authChecked so route guards can redirect to login
        if (!authCheckInitialized) {
            store.dispatch({ type: 'SET_UNAUTHENTICATED' });
            authCheckInitialized = true;
        }
    }
};

// Run initial token check on page load; hourly interval starts after login
checkTokenExpiration();

// When user logs in via login/signup (authenticated becomes true in Redux),
// set up the session without calling getUserData (data is already in Redux)
store.subscribe(() => {
  const { authenticated } = store.getState().loginAuth;
  if (authenticated && !login) {
    login = true;
    const token = localStorage.FBIdToken;
    if (token) {
      axios.defaults.headers.common["Authorization"] = token;
    }
    // Start hourly token check
    if (tokenCheckInterval) clearInterval(tokenCheckInterval);
    tokenCheckInterval = setInterval(checkTokenExpiration, TOKEN_CHECK_INTERVAL);
  }
});
// window.addEventListener('contextmenu', (e) => {
//     e.preventDefault();
// });

const App = () => {
    
    // componentDidMount() {
    //     const token = localStorage.FBIdToken;
    
    //     if (token) {
    //       const decodedToken = jwtDecode(token);
    
    //       if (decodedToken.exp * 1000 < Date.now()) {
    //         store.dispatch(logoutUser());
    //       } else {
    //         axios.defaults.headers.common['Authorization'] = token;
    //         store.dispatch(getUserData({ onLogin: true }));
    //       }
    //     }
        
    // }

    

    
    const [startTime, setStartTime] = useState(Date.now());
    const [totalTime, setTotalTime] = useState(
        parseInt(localStorage.getItem("totalTime")) || 0
    );
    

  
    // const userId = "student-id-123"; // Replace with your user's unique ID
  
    const saveTimeSpentFunc = async () => {
      const endTime = Date.now();
      const timeSpent = Math.floor((endTime - startTime) / 1000); // Time in seconds

        setTotalTime((prev) => {

            const total = parseInt(timeSpent) + parseInt(prev)

            localStorage.setItem("totalTime", total);

            const handle = store.getState().loginAuth.userDetails?.handle
            if (handle) {
                store.dispatch(saveTimeSpent({timeSpent : total, handle: handle}))
            }

            return total;
        });
      
      // Send data to the Cloud Function

    //   await axios.post("https://your-cloud-function-url", {
    //     userId,
    //     timeSpent,
    //   });
    };

    
    useEffect(() => {
      const handleVisibilityChange = () => {

        let token = localStorage.FBIdToken;
    
        if (token) {
            const decodedToken = jwtDecode(token);
    
            if (!(decodedToken.exp * 1000 < Date.now())) {
                if (document.visibilityState === "visible") {
                    setStartTime(Date.now()); // User is active
                } else {
                    saveTimeSpentFunc(); // User switches tabs or leaves
                }
            }
            else{
                localStorage.setItem("totalTime", 0);
            }
        }
        else{
            localStorage.setItem("totalTime", 0);
        }
        
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);
      window.addEventListener("beforeunload", saveTimeSpentFunc);
      
      return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, [startTime]);
    // render() {
        return (
            <Provider store={store}>
                
                <BrowserRouter >

                <PresenceGate />
                <AppNotifications />

                <Switch>
                    
                    <Route exact path="/" component={DATDrillerHome}/>
                    <Route exact path="/Home" component={Home}/>

                    <AuthRoute 
                        exact path="/auth/login" 
                        component={Login} 
                    />
                    <AuthRoute 
                        exact path="/auth/register" 
                        component={Register} 
                    />
                    <AuthRoute 
                        exact path="/auth/forgot-password" 
                        component={ForgotPassword} 
                    />
                    {/* <Route path="/admin" render={(props) => <AdminLayout {...props} />} /> */}
                    {/* <Route path="/auth" render={(props) => <AuthLayout {...props} />} /> */}
                    {/* <Redirect from="/" to="/admin/index" /> */}

                    <AdminRoute
                        path="/admin"
                        component={Admin} 
                    />

                    <ClientRoute
                        path="/client"
                        component={Client} 
                        
                    />
                    <Route exact path="/bootcamp-subscription/accept" component={BootcampAccept} />
                    <Route path="*">
                        <div>
                            <h1>404 - Page Not Found</h1>
                            <p>The page you're looking for doesn't exist.</p>
                        </div>
                    </Route>

                </Switch>
                </BrowserRouter>
            </Provider>
        )
    // }
}

export default (App)

